import React from "react";
import Modal from "@motorata/base-ui.components.molecules.modal";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { P } from "@motorata/base-ui.components.atoms.typography";
import Button from "@motorata/base-ui.components.atoms.button";
import { NextImage } from "../common/Image";

const SuccessModal = ({ show, setShow, image = "/images/send.png" }) => {
  return (
    <Modal title="Twoja wiadomość została wysłana" show={show} setShow={setShow}>
      <Box
        borderRadius="50%"
        margin="0 auto"
        height="200px"
        width="200px"
      >
        <Box width="100%" height="100%">
          <NextImage
            fill
            objectFit="contain"
            priority={true}
            src={image}
            alt="Grafika wysłanej wiadomości"
          />
        </Box>
      </Box>
      <P small textAlign="center">
        Twoja wiadomość została wysłana, nasz zespół skontaktuje się z Tobą najszybciej jak to możliwe.
      </P>
      <Button width="100%" type="secondary" onClick={() => setShow()}>
        Zamknij
      </Button>
    </Modal>
  );
};
export default SuccessModal;
